import React, { useState, useEffect, useContext } from "react";
import logo from "../../assets/images/mayaLogo.png";

import { Transition } from "@headlessui/react";
import { Fade } from "react-reveal";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { getAuth, signOut } from "firebase/auth";
import { AuthContext } from "../../Context/UserContext";
import axiosClient from "../../axios-client";
import defaultAvatar from '../../assets/images/user.png';
import { CgMoreVertical } from "react-icons/cg";
import { FaChevronDown } from "react-icons/fa";
import profileDefault from "../../assets/images/user.png";

function Navbar(props) {
  const { user, setUser, setToken, profile, setProfileId } = useContext(AuthContext);
  const [profilePic, setProfilePic] = useState("");
  // const [profile, setProfile] = useState();
  const [filters, setFilters] = useState({});
  const [categories, setCategories] = useState([]);
  const [visibleCategories, setVisibleCategories] = useState([]);
  const [hiddenCategories, setHiddenCategories] = useState([]);
  const location = useLocation();
  const [showMore, setShowMore] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [show, handleShow] = useState(false);
  const navigate = useNavigate();
  const [openCategory, setOpenCategory] = useState(null);

  const toggleSubcategories = (categoryId) => {
    setOpenCategory(openCategory === categoryId ? null : categoryId);
  };
  // const fetchProfile = async () => {
  //   try {
  //     const response = await axiosClient.get(`/profiles/${profileId}/`); // Replace with your API endpoint
  //     setProfile(response.data);
  //     setFilters(response.data.filters);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };
  useEffect(() => {
    // fetchProfile();

    window.addEventListener("scroll", transitionNavBar);
    return () => {
      window.removeEventListener("scroll", transitionNavBar);
    };


  }, [profile]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsOpen(false); // Close menu when screen is large
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const fetchCategoriesWithSubcategories = async () => {
      try {
        // Fetch categories
        const categoriesResponse = await axiosClient.get("/categories/?page=1&page_size=10000&etat=true&isClient=true");
        const categoriesData = categoriesResponse.data.results;

        // Fetch subcategories for each category
        const categoriesWithSubcategories = await Promise.all(
          categoriesData.map(async (category) => {
            const subcategoriesResponse = await axiosClient.get(
              `/subcategories/category/${category.id}/`
            );
            return {
              ...category,
              subcategories: subcategoriesResponse.data,
            };
          })
        );

        setCategories(categoriesWithSubcategories);
        setVisibleCategories(categoriesWithSubcategories.slice(0, 5))
        setHiddenCategories(categoriesWithSubcategories.slice(5))
        // console.log(categoriesWithSubcategories);


      } catch (error) {
        // console.error("Error fetching categories and subcategories:", error);
      }
    };

    fetchCategoriesWithSubcategories();
  }, []);
  const transitionNavBar = () => {
    if (window.scrollY > 80) {
      handleShow(true);
    } else {
      handleShow(false);
    }
  };

  const onLogout = (ev) => {
    ev.preventDefault();
    setUser({});
    setProfileId(null)
    setToken(null);
    // localStorage.removeItem("profileId");
    navigate("/signin")
  };

  const NavBlack = () => {
    handleShow(true);
  };
  const NavTransparent = () => {
    handleShow(false);
  };


  const [activeCategory, setActiveCategory] = useState("");

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };



  return (
    <header
      className={
        props.playPage
          ? "fixed top-0 z-20 w-full backdrop-blur-sm"
          : "fixed top-0 z-20 w-full"
      }
    >
      <nav
        style={{
          backdropFilter: show || isOpen ? "blur(10px)" : "none",
          WebkitBackdropFilter: show || isOpen ? "blur(10px)" : "none",
          backgroundColor: show || isOpen ? "rgba(0, 0, 0, 0.3)" : "transparent"
        }}
        className={`transition duration-500 ease-in-out  ${(show || isOpen) &&
          "transition duration-500 ease-in-out bg-black/60 "
          // "bg-black/40 backdrop-blur-md supports-[backdrop-filter]:backdrop-blur-md supports-[-webkit-backdrop-filter]:-webkit-backdrop-blur-md"

          } `}
      >
        <div className="px-4 mx-auto max-w-8xl sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">

              <div className="flex-shrink-0">
                <Link
                  to="/home">
                  <img
                    className="h-7 sm:h-7 sm:w-18 lg:ml-8 cursor-pointer"
                    src={logo}
                    alt="Maya+"
                  />
                </Link>

              </div>

              <div className="hidden xl:block">
                <div className="flex items-center ml-10 sm:space-x-1  xl:space-x-2">
                  <Link
                    to="/home"
                    className={` py-2 hover:underline font-semibold transition ease-in-out delay-150 rounded-md cursor-pointer md:px-1 2xl:px-3 sm:text-sm md:text-[16px] 2xl:text-[19px]  ${location.pathname === "/home" ? "text-orange-400" : "text-white"
                      }`}
                  >
                    Accueil
                  </Link>

                  <Link
                    to="/ma-liste"
                    className={`py-2 hover:underline font-semibold transition ease-in-out delay-150 rounded-md cursor-pointer lg:px-3 sm:text-sm md:text-[16px] 2xl:text-[19px] ${location.pathname === "/ma-liste" ? "text-orange-400" : "text-white"
                      }`}
                  >
                    Ma liste
                  </Link>
                  <div
                    onClick={() =>
                      navigate(`/series`, {
                        state: { isSerie: true },
                      })
                    }
                    className={`py-2 hover:underline font-semibold transition ease-in-out delay-150 rounded-md cursor-pointer lg:px-3 sm:text-sm md:text-[16px] 2xl:text-[19px] ${location.pathname === "/series" ? "text-orange-400" : "text-white"
                      }`}
                  >
                    Séries
                  </div>

                  <div className="flex items-center md:space-x-2 xl:space-x-2">
                    {/* Display first 5 categories */}
                    {visibleCategories.map((category) => (
                      <div key={category.id} className="relative group">
                        <div
                          onClick={() =>
                            navigate(`/${category.name.toLowerCase().replace(" ", "-")}`, {
                              state: { catId: category.id },
                            })
                          }
                          className={`py-2 hover:underline font-semibold transition ease-in-out delay-150 rounded-md cursor-pointer md:px-1 2xl:px-3 sm:text-sm md:text-[16px] 2xl:text-[19px] ${location.pathname === `/${category.name.toLowerCase().replace(" ", "-")}`
                            ? "text-orange-400"
                            : "text-white"
                            }`}
                        >
                          {category.name}
                        </div>

                        {/* Subcategories Dropdown */}
                        {category.subcategories?.length > 0 && (
                          <div className="absolute hidden group-hover:block transition ease-in-out delay-150 min-w-[12rem]">
                            <ul className="text-white pt-1 mt-3">
                              {category.subcategories.map((subcategory) => (
                                <li key={subcategory.id}>
                                  <div
                                    onClick={() =>
                                      navigate(`/${category.name.toLowerCase().replace(" ", "-")}/${subcategory.name.toLowerCase().replace(" ", "-")}`, {
                                        state: { catId: category.id, subCatId: subcategory.id },
                                      })
                                    }
                                    className="cursor-pointer bg-black/60 backdrop-blur-md hover:border-l-4 hover:bg-gradient-to-r from-[#ff6a0074] border-orange-400 py-2 px-4 block whitespace-nowrap transition ease-in-out delay-150"
                                  >
                                    {subcategory.name}
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    ))}

                    {/* Show More Dropdown */}
                    {hiddenCategories.length > 0 && (
                      <div className="relative">
                        <div
                          onClick={() => setShowMore(!showMore)} // Toggle state on click
                          className="py-2 px-4 flex gap-1 items-center cursor-pointer font-semibold text-white hover:underline transition ease-in-out delay-150 rounded-md lg:px-3 sm:text-sm md:text-[17px] 2xl:text-[20px]"
                        >
                          {/* Show More ▼ */}
                          plus <CgMoreVertical />
                        </div>

                        {showMore && (  // Only render the dropdown if showMore is true
                          <div id="multi-dropdown" className="absolute divide-y divide-gray-100 w-44">
                            <ul className="text-white pt-1 mt-3">
                              {hiddenCategories.map((category) => (
                                <div key={category.id} className="relative group">
                                  {/* Category Item */}
                                  <div
                                    onClick={() =>
                                      navigate(`/${category.name.toLowerCase().replace(" ", "-")}`, {
                                        state: { catId: category.id },
                                      })
                                    }
                                    className="cursor-pointer bg-black/60 backdrop-blur-md hover:border-l-4 hover:bg-gradient-to-r from-[#ff6a0074] border-orange-400 py-2 px-4 block whitespace-nowrap transition ease-in-out delay-150"
                                  >
                                    {category.name}
                                  </div>

                                  {/* Subcategories Dropdown */}
                                  {category.subcategories?.length > 0 && (
                                    <div className="absolute left-full top-0 hidden group-hover:block transition ease-in-out delay-150 bg-black/60 backdrop-blur-md shadow-lg rounded-md w-50 z-20">
                                      <ul className="text-white ">
                                        {category.subcategories.map((subcategory) => (
                                          <li key={subcategory.id}>
                                            <div
                                              onClick={() =>
                                                navigate(
                                                  `/${category.name.toLowerCase().replace(" ", "-")}/${subcategory.name.toLowerCase().replace(" ", "-")}`,
                                                  {
                                                    state: { catId: category.id, subCatId: subcategory.id },
                                                  }
                                                )
                                              }
                                              className="cursor-pointer bg-black/60 backdrop-blur-md hover:border-l-4 hover:bg-gradient-to-r from-[#ff6a0074] border-orange-400 py-2 px-4 block whitespace-nowrap transition ease-in-out delay-150"
                                            >
                                              {subcategory.name}
                                            </div>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>)}

                  </div>
                </div>
              </div>
            </div>

            <div className="ml-auto">
              <div className="flex items-center gap-4">
                {/* Search Icon */}
                <Link to={"/search"}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="items-center w-10 h-10 pr-4 mt-auto mb-auto text-white hover:text-orange-400 cursor-pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </Link>

                {profile ? (
                  <a className="items-center hidden pr-4 mt-auto mb-auto text-base font-medium text-white transition ease-in-out delay-150 cursor-pointer hover:text-orange-400 md:flex">
                    {profile.username || `${user.first_name} ${user.last_name}`}
                  </a>
                ) : null}

                {/* Notification icon */}
                {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="items-center hidden w-10 h-10 pr-4 mt-auto mb-auto text-white cursor-pointer md:flex"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                  </svg> */}

                <div className="group inline-block relative transition ease-in-out delay-300">
                  <Link to={"/profile"}>
                    {/* {profile?.avatar ? ( */}
                      <img
                        className="border-2 border-orange-400 h-12 w-12 rounded-full cursor-pointer"
                        src={profile.avatar || profileDefault}
                        alt="Profile"
                      />
                    {/* ) : (
                      <div className="border-2 border-orange-400 h-12 w-12 rounded-full flex items-center justify-center bg-[#3b324d] text-white text-xl font-bold cursor-pointer">
                        {profile?.username
                          ? profile.username.split(" ").length === 1
                            ? profile.username.substring(0, 2).toUpperCase() // Take first 2 letters if it's a single word
                            : profile.username
                              .split(" ")
                              .slice(0, 2)
                              .map((name) => name[0]) // Take the first letter of each word
                              .join("")
                              .toUpperCase()
                          : "?"}
                      </div>
                    )} */}

                  </Link>
                  <ul className="absolute hidden text-white pt-1 -ml-32 group-hover:block transition ease-in-out delay-150 min-w-[12rem]">
                    {user.has_active_subscription &&
                      <>
                        <li onClick={() => navigate(`/edit-profile/`, {
                          state: {
                            profileId: profile.id,
                          }
                        })}>
                          <Link

                            className=" cursor-pointer rounded-t bg-black/60 backdrop-blur-md font-bold hover:border-l-4 hover:bg-gradient-to-r from-[#ff6a0074] border-orange-400 py-2 px-4 block whitespace-nowrap transition ease-in-out delay-150"
                          >
                            Modifier mon profil
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={"/my-subscription"}
                            className="cursor-pointer bg-black/60 backdrop-blur-md font-semibold hover:border-l-4 hover:bg-gradient-to-r from-[#ff6a0074] border-orange-400 py-2 px-4 block whitespace-nowrap transition ease-in-out delay-150"
                          >
                            Mon abonnement
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={"/edit-password"}
                            className="cursor-pointer bg-black/60 backdrop-blur-md font-semibold hover:border-l-4 hover:bg-gradient-to-r from-[#ff6a0074] border-orange-400 py-2 px-4 block whitespace-nowrap transition ease-in-out delay-150"
                          >
                            Changer mot de passe
                          </Link>
                        </li>
                      </>
                    }

                    <li>
                      <a
                        onClick={onLogout}
                        className="cursor-pointer rounded-b bg-black/60 backdrop-blur-md font-bold hover:border-l-4 hover:bg-gradient-to-r from-[#ff6a0074] border-orange-400 py-2 px-4 block whitespace-nowrap transition ease-in-out delay-150"
                      >
                        Se déconnecter
                      </a>
                    </li>
                  </ul>

                </div>
              </div>
            </div>

            <div className="flex pl-4 -mr-2 xl:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                className="inline-flex items-center justify-center p-2 text-gray-400 bg-gray-900 rounded-md hover:text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                aria-controls="mobile-menu"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                {!isOpen ? (
                  <svg
                    className="block w-6 h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                    onClick={NavBlack}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                ) : (
                  <svg
                    className="block w-6 h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                    onClick={NavTransparent}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <Transition
          show={isOpen}
          enter="transition ease-out duration-100 transform"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-75 transform"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="xl:hidden" id="mobile-menu">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">


              <a onClick={() => navigate("/home")} className="cursor-pointer block px-3 py-2 text-base font-medium text-white rounded-md hover:bg-orange-400">

                Accueil
              </a>


              <a onClick={() => navigate("/ma-liste")} className="cursor-pointer block px-3 py-2 text-base font-medium text-white rounded-md hover:bg-orange-400">

                Ma liste
              </a>
              
              <a  onClick={() =>
                      navigate(`/series`, {
                        state: { isSerie: true },
                      })
                    } className="cursor-pointer block px-3 py-2 text-base font-medium text-white rounded-md hover:bg-orange-400">

                Séries
              </a>
              
              {categories.map((category) => (
                <div key={category.id} className="relative">
                  {/* Category Item */}
                  <div className="flex items-center justify-between px-3 py-2 text-base font-medium text-white rounded-md hover:bg-orange-400">
                    <span
                      onClick={() =>
                        navigate(`/${category.name.toLowerCase().replace(" ", "-")}`, {
                          state: { catId: category.id },
                        })
                      }
                      className="cursor-pointer"
                    >
                      {category.name}
                    </span>
                    {category.subcategories?.length > 0 && (
                      <FaChevronDown
                        className={`cursor-pointer transition-transform ${openCategory === category.id ? "rotate-180" : ""
                          }`}
                        onClick={() => toggleSubcategories(category.id)}
                      />
                    )}
                  </div>

                  {/* Subcategories Dropdown */}
                  {openCategory === category.id && category.subcategories?.length > 0 && (
                    <div className="ml-4 mt-2">
                      <ul className="text-white">
                        {category.subcategories.map((subcategory) => (
                          <li key={subcategory.id}>
                            <div
                              onClick={() =>
                                navigate(
                                  `/${category.name.toLowerCase().replace(" ", "-")}/${subcategory.name.toLowerCase().replace(" ", "-")}`,
                                  { state: { catId: category.id, subCatId: subcategory.id } }
                                )
                              }
                              className="cursor-pointer bg-black/20 backdrop-blur-md hover:border-l-4 hover:bg-gradient-to-r from-[#ff6a0074] border-orange-400 py-2 px-4 block whitespace-nowrap transition ease-in-out delay-150"
                            >
                              {subcategory.name}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}

              <a
                onClick={onLogout}
                className=" cursor-pointer block px-3 py-2 text-base font-medium text-gray-300 rounded-md hover:bg-orange-400 hover:text-white"
              >
                Se déconnecter
              </a>
            </div>
          </div>

        </Transition>
      </nav>
    </header>
  );
}

export default Navbar;
